import { ProfileDetail } from '../../../components/Profile';

export function ProfileLayout() {
  return <ProfileDetail />;
}
